'use client';
import {Div, useMatches} from '@eon.cz/apollo13-frontend-common';
import {Typography} from '@mui/material';
import {ReactNode} from 'react';

import {FormattedMessage} from 'react-intl';
import {LandingBackground} from './LandingBackground';

type Props = {
    children: ReactNode;
    login?: boolean;
};

/**
 * Wrapper komponenta pro přihlášení a reset hesla
 */
export const LandingLayout = ({children, login}: Props) => {
    const matches = useMatches();

    return (
        <LandingBackground>
            {login ? (
                <Div
                    sx={{
                        backgroundColor: 'background.default',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderRadius: 10,
                        margin: 1,
                        padding: 1,
                    }}
                >
                    <Typography
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontSize: !matches ? 68 : 40,
                        }}
                    >
                        <FormattedMessage id="portal" />
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: 'center',
                            fontSize: !matches ? 28 : 20,
                        }}
                    >
                        <FormattedMessage id="portal.subheader" />
                    </Typography>

                    {children}
                </Div>
            ) : (
                children
            )}
        </LandingBackground>
    );
};
